import { Tooltip } from "./tooltip.js";
import { TooltipStyles, TooltipTemplate } from "@fluentui/web-components";
import { DesignSystem } from "../design-system.js";
/**
 * The Fabric Tooltip component.
 *
 * @public
 */
export const definition = Tooltip.compose({
    name: `${DesignSystem.prefix}-tooltip`,
    template: TooltipTemplate,
    styles: TooltipStyles,
    shadowOptions: {
        mode: DesignSystem.shadowRootMode
    }
});
//# sourceMappingURL=tooltip.definition.js.map